import axiosClient from '../actions/axios-client';

/**
 * Central 401 handling (replaces duplicate logic in api-middleware for axios responses).
 * Invalidates TanStack Query cache and delegates session teardown via onUnauthorized.
 */
export function setupAxiosInterceptors({ queryClient, onUnauthorized }) {
  axiosClient.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const url = error?.config?.url ?? '';
      const skip =
        status !== 401 ||
        url.includes('/admin/logout') ||
        url.includes('/admin/login');

      if (!skip) {
        queryClient.clear();
        onUnauthorized();
      }

      return Promise.reject(error);
    },
  );
}
